import React, { Component } from 'react';

class Header extends Component {

  render() {
    return (
      <div>
        <div className="header__container">
          <h1 className="header__headerOne">SmartDrive</h1>
        </div>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/app/components/Header/Header.js